import React, { useRef, useEffect, useMemo } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { SimpleItem, Label, FormRef } from "devextreme-react/form";
import ITaxes from "../../models/ITaxes";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';

export default function GestionTaxes() {
  const taxeFormDataSource = useCustomDataSource<ITaxes, ITaxes>({ path: "taxe", primaryKey: "idTaxe" });
  const { setMainForm, selectedDataRow: selectedTaxes, mode, onFieldDataChanged, setMode, isFieldModifier, setIsFieldModifier } = taxeFormDataSource;
  const formRef = useRef<FormRef>(null);

  const dateEditorOptions = useMemo(() => {
    return {
      type: 'date',
      displayFormat: 'dd-MM-yyyy',
      width: 160
    };
  }, []);

  const tauxProvincialEditorOptions = useMemo(() => {
    return {
      width: 100,
      step: 0.0001,
      format: '#0.##0,0',
      displayFormat: '#0.##0,0',
      suffix: ' %',
    };
  }, []);

  const tauxFederalEditorOptions = useMemo(() => {
    return {
      width: 100,
      step: 0.0001,
      format: '#0.##0,0',
      displayFormat: '#0.##0,0',
      suffix: ' %'
    };
  }, []);

  const hebergementEditorOptions = useMemo(() => {
    return {
      width: 100,
      step: 0.0001,
      format: '#0.##0,0 $',
      displayFormat: '#0.##0,0 $',
      suffix: ' $',
    };
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  return (
    <FormListBase data={taxeFormDataSource}>
      <FormListBaseGrid dataSource={taxeFormDataSource.dataSource}
        onFocusedRowChanged={() => {
          if (mode === Mode.Modifier) setMode(Mode.Lecture);
        }}
      >
        <Column width={"26%"} key={"grid-col-date-debut"} dataField={"dateDebut"} caption="Début" allowHiding={false} dataType={"datetime"} format={"dd-MM-yyyy HH:mm"} />
        <Column width={"26%"} key={"grid-col-date-fin"} dataField={"dateFin"} caption="Fin" allowHiding={false} dataType={"datetime"} format={"dd-MM-yyyy HH:mm"} />
        <Column key={"grid-col-taux-federal"} dataField={"tauxFederal"} caption="Taux fédéral" allowHiding={false} customizeText={(e) => e.value === null || e.value === undefined || e.value === '' ? '' : `${e.value} %`} />
        <Column key={"grid-col-taux-provincial"} dataField={"tauxProvincial"} caption="Taux provincial" allowHiding={false} customizeText={(e) => e.value === null || e.value === undefined || e.value === '' ? '' : `${e.value} %`} />
        <Column key={"grid-col-hebergement"} dataField={"hebergement"} caption="Taxe hébergement" allowHiding={false} customizeText={(e) => e.value === null || e.value === undefined || e.value === '' ? '0,0 $' : `${e.value} $`} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={``} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      <FormListBaseTab>
        <TabItem title="Informations">
          <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedTaxes || {} as ITaxes} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
            <SimpleItem key={"frm-date-debut"} dataField={"dateDebut"} editorType={"dxDateBox"} editorOptions={dateEditorOptions}>
              <Label text={"Date début"} />
            </SimpleItem>
            <SimpleItem key={"frm-date-fin"} dataField={"dateFin"} editorType={"dxDateBox"} editorOptions={dateEditorOptions}>
              <Label text={"Date fin"} />
            </SimpleItem>
            <SimpleItem key={"frm-taux-provinciale"} dataField={"tauxProvincial"} editorType={"dxNumberBox"} editorOptions={tauxProvincialEditorOptions}>
              <Label text={"Taux provincial"} />
            </SimpleItem>
            <SimpleItem key={"frm-taux-federale"} dataField={"tauxFederal"} editorType={"dxNumberBox"} editorOptions={tauxFederalEditorOptions}>
              <Label text={"Taux fédéral"} />
            </SimpleItem>
            <SimpleItem key={"frm-taxe-hebergement"} dataField={"hebergement"} editorOptions={hebergementEditorOptions}>
              <Label text={"Taxe d'hébergement"} />
            </SimpleItem>
          </Form>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedTaxes || {} as ITaxes} /></TabItem>
      </FormListBaseTab>
    </FormListBase>
  );
}